module.exports = __webpack_public_path__ + "img/pic8.0a30555a.png";